/* ============================================================================
   Sol Suave — V2.6 auto-scrolling rails (used by the testimonials section)
   Drifts right, bounces back left, pauses while the visitor touches it.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bind(list) {
    if (list.dataset.ssAuto) return;
    list.dataset.ssAuto = '1';

    var speed = parseFloat(list.getAttribute('data-autoscroll')) || 0.5;
    var rtl = getComputedStyle(list).direction === 'rtl';
    var dir = 1;
    var pos = 0;
    var paused = false;
    var resumeTimer = null;

    function pause() {
      paused = true;
      clearTimeout(resumeTimer);
    }
    function resumeLater() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        pos = Math.abs(list.scrollLeft);
        paused = false;
      }, 2200);
    }

    ['pointerenter', 'pointerdown', 'touchstart', 'focusin', 'wheel'].forEach(function (ev) {
      list.addEventListener(ev, pause, { passive: true });
    });
    ['pointerleave', 'pointerup', 'touchend', 'focusout'].forEach(function (ev) {
      list.addEventListener(ev, resumeLater, { passive: true });
    });
    list.addEventListener('scroll', function () {
      if (paused) resumeLater();
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause();
      else resumeLater();
    });

    function frame() {
      var max = list.scrollWidth - list.clientWidth;
      if (max > 4 && !paused) {
        pos += dir * speed;
        if (pos >= max) {
          pos = max;
          dir = -1;
        } else if (pos <= 0) {
          pos = 0;
          dir = 1;
        }
        /* RTL browsers report scrollLeft as 0 → -max */
        list.scrollLeft = rtl ? -pos : pos;
      }
      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function init() {
    if (reduceMotion) return;
    document.querySelectorAll('[data-autoscroll]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
